import React, { useState } from "react";
import { CancelPaymentModel } from "../../models/CancelPaymentModel";
import { ChannelModel } from "../../models/ChannelModel";
import { DoPaymentModel } from "../../models/DoPaymentModel";
import { PaymentResultModel } from "../../models/PaymentResultModel";
import { TransactionModel } from "../../models/TransactionModel";
import { PaymentProvider } from "./PaymentProvider";
import { DonationData, MidtransDtoInterface } from "./interfaces/donation-result.interface";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import {
  DonationSingleCartResultInterface,
  DonationSingleResultInterface,
} from "./interfaces/donation-single-result.interface";
import { IPaymuPaymentModel } from "./interfaces/ipaymu-body-request.interface";
import { IPayResponse } from "./interfaces/ipaymu-result.interface";
import { WalletDetalResultInterface } from "./interfaces/wallet-detail-result.interface";
import { BalanceWalletResultInterface } from "./interfaces/balance-wallet-result.interface";
import { GeneralModel } from "../../models/GeneralModel";
import { NicepayResponse } from "./interfaces/nicepay-result.interface";
import {
  NicepayPaymentModel,
  NicepayStatusModel,
} from "./interfaces/nicepay-body-request.interface";
import { NicepayStatusResponseModel } from "../../models/CheckSatusNicepayModel";
import { NicepayStatusResult } from "./interfaces/nicepay-check-status-result.interface";
import { TransactionByInvoiceCodeResult } from "./interfaces/transaction-by-invoice-code-result.interface";
import { IfortepayPaymentResult } from "./interfaces/ifortepay-result.interface";
import { RYFlipResponse } from "./interfaces/ry-flip-result.interface";
import { PlinkResponse } from "./interfaces/plink-result.interface";
import postgrest from "../../api/postgrest";
import qs from "qs";
import https from "https";
import { RyCallbackResponse } from "./interfaces/ry-callback.interface";
import { MANDIRIVAIPaymu } from "../channels/interfaces/midtrans-channel";
import { cleanUserData, trackCapiAndPixel } from "../../helpers/capi.helper";

export type PaymentContextType = {
  paymentResult: PaymentResultModel | undefined;
  paymentResultIpaymu?: IPayResponse;
  paymentResultNicepay?: NicepayResponse;
  paymentResultIfortepay?: IfortepayPaymentResult;
  paymentResultRyFlip?: RYFlipResponse;
  loading: boolean;
  loadingNicepay: boolean;
  transactionModel: TransactionModel | undefined;
  cancelPaymentModel: CancelPaymentModel | undefined;
  transactionStatusModel?: CancelPaymentModel;
  nicepayStatusPayment?: NicepayStatusResponseModel;
  donationDetail?: DonationSingleResultInterface;
  donationDetailCart?: DonationSingleCartResultInterface;
  transactionDetail?: TransactionByInvoiceCodeResult;
  donationDetailForStatus?: DonationSingleResultInterface;
  donationCartDetailForStatus?: DonationSingleCartResultInterface;
  transactionDetailForStatus?: TransactionByInvoiceCodeResult;
  walletDetail?: WalletDetalResultInterface;
  walletDetailStatus?: WalletDetalResultInterface;
  balanceWallet?: BalanceWalletResultInterface;
  deductBalanceResult?: GeneralModel;
  deductLoading?: boolean;
  donationDetailLoading?: boolean;
  transactionDetailLoading?: boolean;
  initPaymentStatus?: string
  setDonationResultV2?: (donationResul: DonationSingleResultInterface) => void;
  setDonationCartResultV2?: (
    donationResul: DonationSingleCartResultInterface
  ) => void;
  doPayment: (channel: ChannelModel, midtransDto: MidtransDtoInterface) => void;
  doPaymentV2: (channel: ChannelModel) => void;
  doPaymentCartV2: (channel: ChannelModel) => void;
  doPaymentCommerce: (channel: ChannelModel) => void;
  doPaymentTopupV2: (channel: ChannelModel) => void;
  doPaymentIpaymu: (channel: ChannelModel) => void;
  doPaymentTopupIpaymuV2: (channel: ChannelModel) => void;
  doPaymentNicepay: (channel: ChannelModel) => void;
  doPaymentIfortepay: (channel: ChannelModel) => void;
  doPaymentFlip: (channel: ChannelModel) => void;
  doPaymentFlipTopupV2: (channel: ChannelModel) => void;
  doPaymentPlink: (channel: ChannelModel) => void;
  paymentResultPlink?: PlinkResponse;
  setPaymentResultPlink: (paymentResult: PlinkResponse) => void;
  checkStatusNicepay: () => void;
  cancelPayment: (orderId: string) => void;
  initPayment: (
    donationId: string,
    paymentId: string,
    vaNumber: string
  ) => Promise<boolean>;
  transactionStatus: (orderId: string) => void;
  transactionStatusCommerce: (orderId: string) => void;
  getDonationDetail: (invoiceCode: string) => void;
  getDonationDetailCart: (invoiceCode: string) => void;
  getTransactionDetail: (invoiceCode: string) => void;
  getTransactionDetailForStatus: (invoiceCode: string) => void;
  getDonationDetailForStatus: (invoiceCode: string) => void;
  getDonationCartDetailForStatus: (invoiceCodeParent: string) => void;
  getWalletDetail: (invoiceCode: string) => void;
  getWalletDetailStatus: (invoiceCode: string) => void;
  getBalanceWalletUser: (userId: string) => void;
  doDeductBalance: (
    userId: string,
    donationId: string,
    donationAmount: number,
    description: string
  ) => void;

};

export const PaymentContext = React.createContext<PaymentContextType | null>(
  null
);

export const PaymentContextProvider: React.FC<React.ReactNode> = ({
  children,
}) => {
  const [paymentResult, setPaymentResult] =
    React.useState<PaymentResultModel>();
  const [paymentResultIpaymu, setPaymentResultIpaymu] =
    React.useState<IPayResponse>();
  const [paymentResultNicepay, setPaymentResultNicepay] =
    React.useState<NicepayResponse>();
  const [paymentResultRyFlip, setPaymentResultRyFlip] =
    React.useState<RYFlipResponse>();
  const [paymentResultPlink, setPaymentResultPlink] =
    React.useState<PlinkResponse>();
  const [transactionModel, setTransactionModel] =
    React.useState<TransactionModel>();
  const [cancelPaymentModel, setCancelPaymentModel] =
    React.useState<CancelPaymentModel>();
  const [transactionStatusModel, setTransactionStatusModel] =
    React.useState<CancelPaymentModel>(undefined);
  const [nicepayStatusPayment, setNicepayStatusPayment] =
    React.useState<NicepayStatusResult>(undefined);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingNicepay, setLoadingNicepay] = React.useState<boolean>(true);
  const [donationDetail, setDonationDetail] =
    React.useState<DonationSingleResultInterface>(undefined);
  const [donationDetailCart, setDonationDetailCart] =
    React.useState<DonationSingleCartResultInterface>(undefined);
  const [donationDetailForStatus, setDonationDetailForStatus] =
    React.useState<DonationSingleResultInterface>(undefined);
  const [donationCartDetailForStatus, setDonationCartDetailForStatus] =
    React.useState<DonationSingleCartResultInterface>(undefined);
  const [walletDetail, setWalletDetail] =
    React.useState<WalletDetalResultInterface>(undefined);
  const [walletDetailStatus, setWalletDetailStatus] =
    React.useState<WalletDetalResultInterface>(undefined);
  const [balanceWallet, setBalanceWallet] =
    React.useState<BalanceWalletResultInterface>(undefined);
  const [deductBalanceResult, setDeductBalanceResult] =
    React.useState<GeneralModel>(undefined);
  const [deductLoading, setDeductLoading] = React.useState<boolean>(false);
  const [donationDetailLoading, setDonationDetailLoading] =
    React.useState<boolean>(false);

  const [transactionDetailLoading, setTransactionDetailLoading] =
    React.useState<boolean>(false);
  const [transactionDetail, setTransactionDetail] =
    React.useState<TransactionByInvoiceCodeResult>(undefined);
  const [transactionDetailForStatus, setTransactionDetailForStatus] =
    React.useState<TransactionByInvoiceCodeResult>(undefined);

  const [paymentResultIfortepay, setPaymentResultIfortepay] = React.useState<IfortepayPaymentResult>(undefined)
  const [initPaymentStatus, setInitPaymentStatus] = useState<string>('request')

  const trackedPurchasesRef = React.useRef<Set<string>>(new Set());
  const trackedAddPaymentRef = React.useRef<Set<string>>(new Set());

  const trackAddPaymentInfoHelper = (
    invoiceCode?: string,
    amount?: number,
    channelName?: string,
    email?: string,
    phone?: string,
    fullName?: string,
    companyId?: string
  ) => {
    if (!invoiceCode) return;
    if (trackedAddPaymentRef.current.has(invoiceCode)) return;
    trackedAddPaymentRef.current.add(invoiceCode);

    trackCapiAndPixel({
      eventName: "AddPaymentInfo",
      eventId: `payinfo_${invoiceCode}`,
      userData: cleanUserData(email, phone, fullName),
      customData: {
        currency: "IDR",
        value: amount,
        order_id: invoiceCode,
        content_name: channelName || "Payment",
        content_type: "product",
      },
      companyId: companyId || process.env.REACT_APP_COMPANY_ID,
    });
  };

  React.useEffect(() => {
    const checkAndTrackPurchase = (
      status?: string,
      invoiceCode?: string,
      amount?: number,
      email?: string,
      phone?: string,
      fullName?: string,
      description?: string,
      companyId?: string
    ) => {
      if (!invoiceCode || !status) return;
      if (
        status !== "settlement" &&
        status !== "capture" &&
        status !== "success"
      ) {
        return;
      }
      if (trackedPurchasesRef.current.has(invoiceCode)) return;

      trackedPurchasesRef.current.add(invoiceCode);
      trackCapiAndPixel({
        eventName: "Purchase",
        eventId: `purchase_${invoiceCode}`,
        userData: cleanUserData(email, phone, fullName),
        customData: {
          currency: "IDR",
          value: amount,
          order_id: invoiceCode,
          content_name: description || "Payment",
          content_type: "product",
        },
        companyId: companyId || process.env.REACT_APP_COMPANY_ID,
      });
    };

    if (walletDetailStatus?.data) {
      checkAndTrackPurchase(
        walletDetailStatus.data.status,
        walletDetailStatus.data.invoice_code,
        walletDetailStatus.data.amount,
        walletDetailStatus.data.user_email,
        walletDetailStatus.data.user_phone_number,
        walletDetailStatus.data.user_full_name,
        walletDetailStatus.data.description,
        walletDetailStatus.data.company_id
      );
    }

    if (donationDetailForStatus?.data) {
      const d = donationDetailForStatus.data;
      const dCustom = d as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string };
      checkAndTrackPurchase(
        d.status,
        d.order_id || d.invoice_code,
        d.amount,
        d.customer_email || dCustom.donor_email,
        d.customer_phone || dCustom.donor_phone_number,
        d.customer_name || dCustom.donor_name,
        d.program?.title || d.program_name,
        d.company_id
      );
    }

    if (
      donationCartDetailForStatus?.data &&
      donationCartDetailForStatus.data.length > 0
    ) {
      const first = donationCartDetailForStatus.data[0];
      const firstCustom = first as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string };
      const totalAmount = donationCartDetailForStatus.data.reduce(
        (sum, item) => sum + (item.amount || 0),
        0
      );
      checkAndTrackPurchase(
        first.status,
        first.invoice_code || first.order_id,
        totalAmount,
        first.customer_email || firstCustom.donor_email,
        first.customer_phone || firstCustom.donor_phone_number,
        first.customer_name || firstCustom.donor_name,
        first.program?.title || first.program_name,
        first.company_id
      );
    }

    if (transactionDetailForStatus?.data) {
      checkAndTrackPurchase(
        transactionDetailForStatus.data.status,
        transactionDetailForStatus.data.invoice_code,
        transactionDetailForStatus.data.total_amount,
        transactionDetailForStatus.data.customer_email,
        transactionDetailForStatus.data.customer_phone,
        transactionDetailForStatus.data.customer_name,
        "Commerce Order",
        transactionDetailForStatus.data.trx?.[0]?.company_id
      );
    }

    if (transactionStatusModel?.data) {
      const dCustom = donationDetail?.data as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      checkAndTrackPurchase(
        transactionStatusModel.data.transaction_status,
        transactionStatusModel.data.order_id,
        parseFloat(transactionStatusModel.data.gross_amount || "0"),
        donationDetail?.data?.customer_email || dCustom?.donor_email,
        donationDetail?.data?.customer_phone || dCustom?.donor_phone_number,
        donationDetail?.data?.customer_name || dCustom?.donor_name,
        donationDetail?.data?.program?.title || donationDetail?.data?.program_name
      );
    }

    if (paymentResult?.data) {
      const dCustom = donationDetail?.data as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      checkAndTrackPurchase(
        paymentResult.data.transaction_status,
        paymentResult.data.order_id,
        paymentResult.data.gross_amount,
        walletDetail?.data?.user_email || donationDetail?.data?.customer_email || dCustom?.donor_email,
        walletDetail?.data?.user_phone_number || donationDetail?.data?.customer_phone || dCustom?.donor_phone_number,
        walletDetail?.data?.user_full_name || donationDetail?.data?.customer_name || dCustom?.donor_name
      );
    }

    if (nicepayStatusPayment?.data) {
      const isSuccess =
        nicepayStatusPayment.data.status === "0000" ||
        nicepayStatusPayment.data.status === "success";
      if (isSuccess) {
        const dCustom = donationDetailForStatus?.data as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
        checkAndTrackPurchase(
          "success",
          nicepayStatusPayment.data.tXid || donationDetailForStatus?.data?.order_id,
          donationDetailForStatus?.data?.amount,
          donationDetailForStatus?.data?.customer_email || dCustom?.donor_email,
          donationDetailForStatus?.data?.customer_phone || dCustom?.donor_phone_number,
          donationDetailForStatus?.data?.customer_name || dCustom?.donor_name,
        donationDetailForStatus?.data?.program?.title
        );
      }
    }
  }, [
    walletDetailStatus,
    donationDetailForStatus,
    donationCartDetailForStatus,
    transactionDetailForStatus,
    transactionStatusModel,
    paymentResult,
    nicepayStatusPayment,
    donationDetail,
    walletDetail,
  ]);
  const setDonationResultV2 = (
    donationResult: DonationSingleResultInterface
  ) => {
    setDonationDetail(donationResult);
  };

  const setDonationCartResultV2 = (
    donationResult: DonationSingleCartResultInterface
  ) => {
    setDonationDetailCart(donationResult);
  };

  const initPayment = async (
    donationId: string,
    paymentId: string,
    vaNumber: string
  ): Promise<boolean> => {
    setInitPaymentStatus('request')
    var paymentProvider: PaymentProvider = new PaymentProvider();
    await paymentProvider.initPayment(
      donationId,
      paymentId,
      vaNumber
    );
    if (process.env.REACT_APP_COMPANY_ID === 'c719ac4a-dedb-4102-8be0-f78898f7cd35') {
      await sendToSenyumSehat({ donationId: donationId })
    }
    setInitPaymentStatus('done')
    return true;
  };

  const sendToSenyumSehat = async ({
    donationId,
  }: {
    donationId: string
  }): Promise<boolean | null> => {
    try {
      const responses = await axios.post(
        "https://rybroker.universa.vip/ry-salamsehat",
        // "http://localhost:5012/ry-salamsehat",
        {
          donation_id: donationId,
        },
      );
      console.log(responses.data)
      return true
    } catch (e) {
      console.log(e)
      return false;
    }
  };

  const transactionStatus = async (orderId: string) => {
    var paymentProvider: PaymentProvider = new PaymentProvider();
    const response = await paymentProvider.transactionStatus(orderId);
    setTransactionStatusModel(response);
  };

  const transactionStatusCommerce = async (orderId: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.transactionStatusCommerce(orderId);
      if (response?.status) {
        setPaymentResult(response);
      }
    } catch {
      // ponytail: ignore network errors during status polling
    }
  };

  const doPaymentCommerce = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    console.log("zxczxc", transactionDetail);

    try {
      let doPaymentModel: DoPaymentModel = undefined;

      if (channel.payment_type === "echannel") {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: transactionDetail?.data?.total_amount,
            order_id: transactionDetail?.data?.invoice_code,
          },
          customer_details: {
            email: transactionDetail?.data?.customer_email,
            first_name: transactionDetail?.data?.customer_name,
            last_name: "",
            phone: transactionDetail?.data?.customer_phone,
          },
          // item_details: midtransDto.item_details,
          echannel: channel.echannel,
        };
      } else {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: transactionDetail?.data?.total_amount,
            order_id: transactionDetail?.data?.invoice_code,
          },
          customer_details: {
            email: transactionDetail?.data?.customer_email,
            first_name: transactionDetail?.data?.customer_name,
            last_name: "",
            phone: transactionDetail?.data?.customer_phone,
          },
          // item_details: midtransDto?.,
          bank_transfer: {
            bank: channel.code,
          },
        };
      }

      switch (channel.payment_type) {
        case "cstore":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            cstore: {
              store: channel.code,
            },
          };
          break;
        case "gopay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            gopay: {
              enable_callback: true,
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "shopeepay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "shopeepay",
            enabled_payments: ["shopeepay"],
            shopeepay: {
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "qris":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "qris",
          };
          break;
      }

      let result = await paymentProvider.doPayment(doPaymentModel);
      setPaymentResult(result);
      trackAddPaymentInfoHelper(
        transactionDetail?.data?.invoice_code,
        transactionDetail?.data?.total_amount,
        channel.title,
        transactionDetail?.data?.customer_email,
        transactionDetail?.data?.customer_phone,
        transactionDetail?.data?.customer_name,
        transactionDetail?.data?.trx?.[0]?.company_id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResult(e);
      setLoading(false);
    }
  };

  const doPaymentCartV2 = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    let totalAmount = 0;
    let invoiceCodeParent = donationDetailCart.data[0].invoice_code_parent;
    for (const donation of donationDetailCart.data) {
      totalAmount += donation.amount;
    }

    try {
      let doPaymentModel: DoPaymentModel = undefined;

      if (channel.payment_type === "echannel") {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: totalAmount,
            order_id: invoiceCodeParent,
          },
          customer_details: {
            email: donationDetailCart.data[0].customer_email,
            first_name: donationDetailCart.data[0].customer_name,
            last_name: "",
            phone: donationDetailCart.data[0].customer_phone,
          },
          // item_details: midtransDto.item_details,
          echannel: channel.echannel,
        };
      } else {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: totalAmount,
            order_id: invoiceCodeParent,
          },
          customer_details: {
            email: donationDetailCart.data[0].customer_email,
            first_name: donationDetailCart.data[0].customer_name,
            last_name: "",
            phone: donationDetailCart.data[0].customer_phone,
          },
          // item_details: midtransDto?.,
          bank_transfer: {
            bank: channel.code,
          },
        };
      }

      switch (channel.payment_type) {
        case "cstore":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            cstore: {
              store: channel.code,
            },
          };
          break;
        case "gopay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            gopay: {
              enable_callback: true,
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "shopeepay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "shopeepay",
            enabled_payments: ["shopeepay"],
            shopeepay: {
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "qris":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "qris",
          };
          break;
      }

      let result = await paymentProvider.doPayment(doPaymentModel);
      setPaymentResult(result);
      const cartFirst = donationDetailCart?.data?.[0];
      const cartFirstCustom = cartFirst as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        cartFirst?.invoice_code,
        totalAmount,
        channel.title,
        cartFirst?.customer_email || cartFirstCustom?.donor_email,
        cartFirst?.customer_phone || cartFirstCustom?.donor_phone_number,
        cartFirst?.customer_name || cartFirstCustom?.donor_name,
        cartFirst?.company_id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResult(e);
      setLoading(false);
    }
  };

  const doPaymentV2 = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    console.log("zxczxc", donationDetail);

    try {
      let doPaymentModel: DoPaymentModel = undefined;

      if (channel.payment_type === "echannel") {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: donationDetail?.data?.amount,
            order_id: donationDetail?.data?.invoice_code,
          },
          customer_details: {
            email: donationDetail?.data?.customer_email,
            first_name: donationDetail?.data?.customer_name,
            last_name: "",
            phone: donationDetail?.data?.customer_phone,
          },
          // item_details: midtransDto.item_details,
          echannel: channel.echannel,
        };
      } else {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: donationDetail?.data?.amount,
            order_id: donationDetail?.data?.invoice_code,
          },
          customer_details: {
            email: donationDetail?.data?.customer_email,
            first_name: donationDetail?.data?.customer_name,
            last_name: "",
            phone: donationDetail?.data?.customer_phone,
          },
          // item_details: midtransDto?.,
          bank_transfer: {
            bank: channel.code,
          },
        };
      }

      switch (channel.payment_type) {
        case "cstore":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            cstore: {
              store: channel.code,
            },
          };
          break;
        case "gopay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            gopay: {
              enable_callback: true,
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "shopeepay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "shopeepay",
            enabled_payments: ["shopeepay"],
            shopeepay: {
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "qris":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "qris",
          };
          break;
      }

      let result = await paymentProvider.doPayment(doPaymentModel);
      setPaymentResult(result);
      const donData = donationDetail?.data;
      const donCustom = donData as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        donData?.invoice_code,
        donData?.amount,
        channel.title,
        donData?.customer_email || donCustom?.donor_email,
        donData?.customer_phone || donCustom?.donor_phone_number,
        donData?.customer_name || donCustom?.donor_name,
        donData?.company_id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResult(e);
      setLoading(false);
    }
  };

  const doPaymentTopupIpaymuV2 = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      let customerEmail = response?.data?.email_smtp_user;
      if (walletDetail?.data?.user_email !== "") {
        customerEmail = walletDetail?.data?.user_email;
      }
      const ipaymuBodyReq: IPaymuPaymentModel = {
        name: walletDetail?.data?.user_full_name,
        phone: walletDetail?.data?.user_phone_number,
        email: customerEmail,
        amount: walletDetail?.data?.amount?.toString(),
        product: `${response?.data?.brand_name} Wallet`,
        returnUrl: `${response?.data?.platform_donation}/payment/success`,
        cancelUrl: `${response?.data?.platform_donation}/payment/failed`,
        orderId: walletDetail?.data?.invoice_code,
        paymentMethod: channel?.payment_type,
        paymentChannel: channel?.code,
        comments: `Payment for ${walletDetail?.data?.invoice_code}`,
      };
      const result = await paymentProvider.initPaymentIPaymu(ipaymuBodyReq);
      console.log(result);
      setPaymentResultIpaymu(result);
      trackAddPaymentInfoHelper(
        walletDetail?.data?.invoice_code,
        walletDetail?.data?.amount,
        channel.title,
        walletDetail?.data?.user_email,
        walletDetail?.data?.user_phone_number,
        walletDetail?.data?.user_full_name,
        walletDetail?.data?.company_id
      );
      setLoading(false);
    } catch (e) {
      console.log(e);
      setPaymentResultIpaymu(undefined);
      setLoading(false);
    }
  };

  const doPaymentTopupV2 = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    console.log("zxczxc", donationDetail);

    try {
      let doPaymentModel: DoPaymentModel = undefined;

      if (channel.payment_type === "echannel") {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: walletDetail?.data?.amount,
            order_id: walletDetail?.data?.invoice_code,
          },
          customer_details: {
            email: walletDetail?.data?.user_email,
            first_name: walletDetail?.data?.user_full_name,
            last_name: "",
            phone: walletDetail?.data?.user_phone_number,
          },
          // item_details: midtransDto.item_details,
          echannel: channel.echannel,
        };
      } else {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: walletDetail?.data?.amount,
            order_id: walletDetail?.data?.invoice_code,
          },
          customer_details: {
            email: walletDetail?.data?.user_email,
            first_name: walletDetail?.data?.user_full_name,
            last_name: "",
            phone: walletDetail?.data?.user_phone_number,
          },
          // item_details: midtransDto?.,
          bank_transfer: {
            bank: channel.code,
          },
        };
      }

      switch (channel.payment_type) {
        case "cstore":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            cstore: {
              store: channel.code,
            },
          };
          break;
        case "gopay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            gopay: {
              enable_callback: true,
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "shopeepay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "shopeepay",
            enabled_payments: ["shopeepay"],
            shopeepay: {
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "qris":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            payment_type: "qris",
          };
          break;
      }

      let result = await paymentProvider.doPayment(doPaymentModel);
      setPaymentResult(result);
      trackAddPaymentInfoHelper(
        walletDetail?.data?.invoice_code,
        walletDetail?.data?.amount,
        channel.title,
        walletDetail?.data?.user_email,
        walletDetail?.data?.user_phone_number,
        walletDetail?.data?.user_full_name,
        walletDetail?.data?.company_id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResult(e);
      setLoading(false);
    }
  };

  const doPayment = async (
    channel: ChannelModel,
    midtransDto: MidtransDtoInterface
  ) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      let doPaymentModel: DoPaymentModel = undefined;

      if (channel.payment_type === "echannel") {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: midtransDto?.transaction_details?.gross_amount,
            order_id: midtransDto?.transaction_details?.order_id,
          },
          customer_details: {
            email: midtransDto.customer_details?.email,
            first_name: midtransDto.customer_details?.first_name,
            last_name: midtransDto.customer_details?.last_name,
            phone: midtransDto.customer_details?.phone,
          },
          // item_details: midtransDto.item_details,
          echannel: channel.echannel,
        };
      } else {
        doPaymentModel = {
          payment_type: channel.payment_type,
          transaction_details: {
            gross_amount: midtransDto?.transaction_details?.gross_amount,
            order_id: midtransDto?.transaction_details?.order_id,
          },
          customer_details: {
            email: midtransDto?.customer_details?.email,
            first_name: midtransDto?.customer_details?.first_name,
            last_name: midtransDto?.customer_details?.last_name,
            phone: midtransDto?.customer_details?.phone,
          },
          // item_details: midtransDto?.,
          bank_transfer: {
            bank: channel.code,
          },
        };
      }

      switch (channel.payment_type) {
        case "cstore":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            cstore: {
              store: channel.code,
            },
          };
          break;
        case "gopay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            gopay: {
              enable_callback: true,
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
        case "shopeepay":
          delete doPaymentModel.bank_transfer;
          doPaymentModel = {
            ...doPaymentModel,
            shopeepay: {
              callback_url: response?.data?.platform_donation,
            },
          };
          break;
      }

      let result = await paymentProvider.doPayment(doPaymentModel);
      setPaymentResult(result);
      trackAddPaymentInfoHelper(
        midtransDto?.transaction_details?.order_id,
        midtransDto?.transaction_details?.gross_amount,
        channel.title,
        midtransDto?.customer_details?.email,
        midtransDto?.customer_details?.phone,
        `${midtransDto?.customer_details?.first_name || ""} ${midtransDto?.customer_details?.last_name || ""}`.trim()
      );
      setLoading(false);
    } catch (e) {
      setPaymentResult(e);
      setLoading(false);
    }
  };

  const cancelPayment = async (orderId: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();
      let response = await paymentProvider.cancelPayment(orderId);
      setCancelPaymentModel(response);
    } catch (e) {
      setCancelPaymentModel(undefined);
    }
  };

  const getDonationDetail = async (invoiceCode: string) => {
    try {
      setDonationDetailLoading(true);
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.getDonationDetail(invoiceCode);
      setDonationDetail(response);
      setDonationDetailLoading(false);
    } catch (e) {
      setDonationDetail(undefined);
      setDonationDetailLoading(false);
    }
  };

  const getDonationDetailCart = async (invoiceCode: string) => {
    try {
      setDonationDetailLoading(true);
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.getDonationDetailCart(invoiceCode);
      setDonationDetailCart(response);
      setDonationDetailLoading(false);
    } catch (e) {
      setDonationDetailCart(undefined);
      setDonationDetailLoading(false);
    }
  };

  const getTransactionDetail = async (invoiceCode: string) => {
    try {
      setTransactionDetailLoading(true);
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.getTransactionDetail(invoiceCode);
      setTransactionDetail(response);
      setTransactionDetailLoading(false);
    } catch (e) {
      setTransactionDetail(undefined);
      setTransactionDetailLoading(false);
    }
  };

  // const uploadProofOfPayment = async (invoiceCode: string) => {
  //   try {

  //   }
  // }

  const getDonationDetailForStatus = async (invoiceCode: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();

      const response = await paymentProvider.getDonationDetail(invoiceCode);
      setDonationDetailForStatus(response);
    } catch (e) {
      setDonationDetailForStatus(undefined);
    }
  };

  const getDonationCartDetailForStatus = async (invoiceCodeParent: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();

      const response = await paymentProvider.getDonationDetailCart(
        invoiceCodeParent
      );
      setDonationCartDetailForStatus(response);
    } catch (e) {
      setDonationCartDetailForStatus(undefined);
    }
  };

  const getTransactionDetailForStatus = async (invoiceCode: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();

      const response = await paymentProvider.getTransactionDetail(invoiceCode);
      setTransactionDetailForStatus(response);
    } catch (e) {
      setTransactionDetailForStatus(undefined);
    }
  };

  const doPaymentIpaymu = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      let customerEmail = response?.data?.email_smtp_user;
      if (donationDetail?.data?.customer_email !== "") {
        customerEmail = donationDetail?.data?.customer_email;
      }
      const ipaymuBodyReq: IPaymuPaymentModel = {
        name: donationDetail?.data?.customer_name,
        phone: donationDetail?.data?.customer_phone,
        email: customerEmail,
        amount: donationDetail?.data?.amount?.toString(),
        product: donationDetail?.data?.program_name,
        returnUrl: `${response?.data?.platform_donation}/payment/success`,
        cancelUrl: `${response?.data?.platform_donation}/payment/failed`,
        orderId: donationDetail?.data?.order_id,
        paymentMethod: channel?.payment_type,
        paymentChannel: channel?.code,
        comments: `Payment for ${donationDetail?.data?.program_name}`,
      };
      const result = await paymentProvider.initPaymentIPaymu(ipaymuBodyReq);
      console.log(result);

      if (result.status === true) {
        if (result.data.Status === 200) {
          await postgrest
            .from("donations")
            .update({
              va_number: result.data.Data.PaymentNo,
              // amount: result.data.Data.Total,
            })
            .eq("invoice_code_parent", donationDetail?.data?.invoice_code_parent);
        }
      }

      setPaymentResultIpaymu(result);
      const ipayDon = donationDetail?.data;
      const ipayDonCustom = ipayDon as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        ipayDon?.invoice_code,
        ipayDon?.amount,
        channel.title,
        ipayDon?.customer_email || ipayDonCustom?.donor_email,
        ipayDon?.customer_phone || ipayDonCustom?.donor_phone_number,
        ipayDon?.customer_name || ipayDonCustom?.donor_name,
        ipayDon?.company_id
      );
      setLoading(false);
    } catch (e) {
      console.log(e);
      setPaymentResultIpaymu(undefined);
      setLoading(false);
    }
  };

  const doPaymentNicepay = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      const niceBodyReq: NicepayPaymentModel = {
        payMethod: channel.payment_type,
        currency: "IDR",
        amt: donationDetail?.data?.amount?.toString(),
        referenceNo: donationDetail?.data?.invoice_code,
        mitraCd: "",
        goodsNm: donationDetail?.data?.payment_name,
        cartData: "{}",
        billingNm: donationDetail?.data?.customer_name,
        billingPhone: donationDetail?.data?.customer_phone,
        billingEmail: donationDetail?.data?.customer_email,
        billingAddr: "",
        billingCity: "",
        billingState: "Jakarta",
        billingPostCd: "55555",
        billingCountry: "Indonesia",

        description:
          donationDetail?.data?.program?.description ||
          donationDetail?.data?.program_name,
        userSessionID:
          donationDetail?.data?.created_by || donationDetail?.data?.customer_id,
        bankCd: channel?.code,
      };
      const result = await paymentProvider.initPaymentNicepay(niceBodyReq);
      console.log(result);
      setPaymentResultNicepay(result);
      const niceDon = donationDetail?.data;
      const niceDonCustom = niceDon as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        niceDon?.invoice_code,
        niceDon?.amount,
        channel.title,
        niceDon?.customer_email || niceDonCustom?.donor_email,
        niceDon?.customer_phone || niceDonCustom?.donor_phone_number,
        niceDon?.customer_name || niceDonCustom?.donor_name,
        niceDon?.company_id
      );
      setLoading(false);
    } catch (e) {
      console.log(e);
      setPaymentResultNicepay(undefined);
      setLoading(false);
    }
  };

  const doPaymentFlip = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      let totalAmount = 0;
      let invoiceCodeParent = donationDetailCart.data[0].invoice_code_parent;
      let invoiceCode = donationDetailCart.data[0].invoice_code;
      for (const donation of donationDetailCart.data) {
        totalAmount += donation.amount;
      }

      const form = {
        invoice_number: invoiceCodeParent,
        title: donationDetailCart.data[0].program_name,
        amount: totalAmount.toString(),
        expired_date: "",
        redirect_url: "https://rumah-yatim.org",
        name: donationDetailCart.data[0].customer_name,
        email: donationDetailCart.data[0].customer_email,
        phone: donationDetailCart.data[0].customer_phone,
        address: "Bandung",
        bank_name: channel?.title,
        bank_code: channel?.code,
        payment_method: channel?.payment_type,
        vendor: "RumahYatim",
        company_id: response.data?.id,
        invoice_code: invoiceCode,
        invoice_code_parent: invoiceCodeParent
      }

      const result = await paymentProvider.initPaymenyRyFlip(form)
      console.log(result);
      setPaymentResultRyFlip(result);
      const flipFirst = donationDetailCart?.data?.[0];
      const flipFirstCustom = flipFirst as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        flipFirst?.invoice_code,
        totalAmount,
        channel.title,
        flipFirst?.customer_email || flipFirstCustom?.donor_email,
        flipFirst?.customer_phone || flipFirstCustom?.donor_phone_number,
        flipFirst?.customer_name || flipFirstCustom?.donor_name,
        flipFirst?.company_id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResultRyFlip(undefined);
      setLoading(false);
    }
  }

  const doPaymentFlipTopupV2 = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    let donorEmail = ""
    let donorName = ""
    let donorPhone = ""

    if (walletDetail) {
      donorEmail = walletDetail?.data?.user_email?.split("@@")[0] || walletDetail?.data?.user_email
      donorName = walletDetail?.data?.user_full_name?.split("@@")[0] || walletDetail?.data?.user_full_name
      donorPhone = walletDetail?.data?.user_phone_number?.split("@@")[0] || walletDetail?.data?.user_phone_number
    }

    try {
      const form = {
        invoice_number: walletDetail?.data?.invoice_code,
        title: "Topup Wallet",
        amount: walletDetail?.data?.amount?.toString(),
        expired_date: "",
        redirect_url: "https://rumah-yatim.org",
        name: donorName,
        email: donorEmail,
        phone: donorPhone,
        address: "Bandung",
        bank_name: channel?.title,
        bank_code: channel?.code,
        payment_method: channel?.payment_type,
        vendor: "RumahYatim",
        company_id: response.data?.id,
        invoice_code: walletDetail?.data?.invoice_code,
        invoice_code_parent: walletDetail?.data?.invoice_code
      }

      const result = await paymentProvider.initPaymenyRyFlip(form)
      console.log(result);
      setPaymentResultRyFlip(result);
      trackAddPaymentInfoHelper(
        walletDetail?.data?.invoice_code,
        walletDetail?.data?.amount,
        channel.title,
        donorEmail,
        donorPhone,
        donorName,
        response.data?.id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResultRyFlip(undefined);
      setLoading(false);
    }
  }

  const doPaymentPlink = async (_channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const companyData = company.data as CompanySingleResultInterface;

    setLoading(true);

    try {
      let totalAmount = 0;
      const firstDonation = donationDetailCart.data[0];
      for (const donation of donationDetailCart.data) {
        totalAmount += donation.amount;
      }

      const body = {
        invoice_code: firstDonation.invoice_code,
        invoice_code_parent: firstDonation.invoice_code_parent,
        donation_id: firstDonation.id,
        donor_name: firstDonation.customer_name,
        donor_phone: firstDonation.customer_phone,
        donor_email: firstDonation.customer_email,
        amount: totalAmount,
        program_id: firstDonation.program_id,
        program_name: firstDonation.program_name,
        program_slug: firstDonation.program_slug,
        created_at: firstDonation.created_at,
        company_id: companyData.data?.id,
      };

      const result = await axios.post(
        "https://n8n.universa.vip/webhook/plink-req-payment-page",
        body,
        { headers: { "content-type": "application/json" } }
      );

      setPaymentResultPlink(result.data);
      const plinkFirst = donationDetailCart?.data?.[0];
      const plinkFirstCustom = plinkFirst as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        plinkFirst?.invoice_code,
        totalAmount,
        _channel?.title,
        plinkFirst?.customer_email || plinkFirstCustom?.donor_email,
        plinkFirst?.customer_phone || plinkFirstCustom?.donor_phone_number,
        plinkFirst?.customer_name || plinkFirstCustom?.donor_name,
        companyData.data?.id
      );
      setLoading(false);
    } catch (e) {
      setPaymentResultPlink(undefined);
      setLoading(false);
    }
  };

  const doPaymentIfortepay = async (channel: ChannelModel) => {
    const company = await axios.get(
      `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
    );
    const response = company.data as CompanySingleResultInterface;

    setLoading(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {

      let customerEmail = response?.data?.email_smtp_user;
      if (donationDetail?.data?.customer_email !== "") {
        customerEmail = donationDetail?.data?.customer_email;
      }

      const bodyIfortepay = {
        company_id: response.data?.id ?? "",
        order_id: donationDetail?.data?.order_id,
        amount: +donationDetail?.data?.amount,
        product_id: "Daafi Umroh Hajj",
        product_name: donationDetail?.data?.program_name,
        customer_name: donationDetail?.data?.customer_name,
        customer_email: customerEmail,
        customer_phone: donationDetail?.data?.customer_phone
      }
      const result = await paymentProvider.initPaymentIfortepay(bodyIfortepay);
      console.log(result);
      setPaymentResultIfortepay(result);
      const iforteDon = donationDetail?.data;
      const iforteDonCustom = iforteDon as unknown as { donor_email?: string; donor_phone_number?: string; donor_name?: string } | undefined;
      trackAddPaymentInfoHelper(
        iforteDon?.invoice_code,
        iforteDon?.amount,
        channel.title,
        customerEmail,
        iforteDon?.customer_phone || iforteDonCustom?.donor_phone_number,
        iforteDon?.customer_name || iforteDonCustom?.donor_name,
        response.data?.id
      );
      setLoading(false);
    } catch (e) {
      console.log(e);
      setPaymentResultIfortepay(undefined)
      setLoading(false);
    }
  }

  const checkStatusNicepay = async () => {
    setLoadingNicepay(true);

    var paymentProvider: PaymentProvider = new PaymentProvider();

    try {
      const niceBodyReq: NicepayStatusModel = {
        tXid: paymentResultNicepay?.data?.tXid,
        referenceNo: donationDetail?.data?.invoice_code,
        amt: donationDetail?.data?.amount?.toString(),
      };

      const result = await paymentProvider.initStatusNicepay(niceBodyReq);
      setNicepayStatusPayment(result);
      setLoadingNicepay(false);
    } catch (e) {
      console.log(e);
      setNicepayStatusPayment(undefined);
      setLoadingNicepay(false);
    }
  };

  const getWalletDetail = async (invoiceCode: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.checkWalletDetail(invoiceCode);
      setWalletDetail(response);
    } catch (e) {
      setWalletDetail(undefined);
    }
  };

  const getWalletDetailStatus = async (invoiceCode: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.checkWalletDetail(invoiceCode);
      setWalletDetailStatus(response);
    } catch (e) {
      setWalletDetailStatus(undefined);
    }
  };

  const getBalanceWalletUser = async (userId: string) => {
    try {
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.balanceWalletUser(userId);
      setBalanceWallet(response);
    } catch (e) {
      setWalletDetailStatus(undefined);
    }
  };

  const doDeductBalance = async (
    userId: string,
    donationId: string,
    donationAmount: number,
    description: string
  ) => {
    try {
      setDeductLoading(true);
      var paymentProvider: PaymentProvider = new PaymentProvider();
      const response = await paymentProvider.deductWallet(
        userId,
        donationId,
        donationAmount,
        description
      );
      setDeductBalanceResult(response);
      setDeductLoading(false);
    } catch (e) {
      setDeductBalanceResult(undefined);
      setDeductLoading(false);
    }
  };

  return (
    <PaymentContext.Provider
      value={{
        paymentResult,
        loading,
        loadingNicepay,
        doPayment,
        transactionModel,
        cancelPayment,
        cancelPaymentModel,
        initPayment,
        transactionStatus,
        transactionStatusModel,
        nicepayStatusPayment,
        donationDetail,
        donationDetailCart,
        getDonationDetail,
        getDonationDetailCart,
        doPaymentV2,
        doPaymentCartV2,
        setDonationResultV2,
        setDonationCartResultV2,
        doPaymentIpaymu,
        paymentResultIpaymu,
        doPaymentNicepay,
        checkStatusNicepay,
        paymentResultNicepay,
        getDonationDetailForStatus,
        getDonationCartDetailForStatus,
        donationDetailForStatus,
        donationCartDetailForStatus,
        walletDetail,
        walletDetailStatus,
        getWalletDetail,
        getWalletDetailStatus,
        doPaymentTopupV2,
        getBalanceWalletUser,
        balanceWallet,
        doDeductBalance,
        deductBalanceResult,
        deductLoading,
        donationDetailLoading,
        transactionDetail,
        transactionDetailLoading,
        getTransactionDetail,
        doPaymentCommerce,
        transactionStatusCommerce,
        transactionDetailForStatus,
        getTransactionDetailForStatus,
        doPaymentTopupIpaymuV2,
        doPaymentIfortepay,
        paymentResultIfortepay,
        doPaymentFlip,
        doPaymentFlipTopupV2,
        paymentResultRyFlip,
        doPaymentPlink,
        paymentResultPlink,
        setPaymentResultPlink,
        initPaymentStatus
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

